import React, { useState } from 'react';
import DefaultModal from '@/components/DefaultModal';
import { Content, Text } from './styles';

interface Props {
  onConfirm: (checkboxValue: boolean) => void;
  onCancel: () => void;
  onClose: () => void;
  isOpen: boolean;
}

const ExportModal = (props: Props) => {
  const { onConfirm, onCancel, onClose, isOpen } = props;
  const [checkboxValue, setCheckboxValue] = useState(true);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxValue(event.target.checked);
  };

  return (
    <DefaultModal
      title="Opções de exportação"
      onConfirm={() => onConfirm(checkboxValue)}
      onCancel={onCancel}
      onClose={onClose}
      isOpen={isOpen}>
      <Content>
        <input type="checkbox" checked={checkboxValue} onChange={onChange} />
        <Text>Exportar dados em formato codificado</Text>
      </Content>
    </DefaultModal>
  );
};

export default ExportModal;
